import React from 'react'

import { IMaskInput } from 'react-imask'
import classNames from 'classnames'
import { useField } from 'formik'

import { FieldError } from '@components/form'
import { FieldProps } from '@components/form/types'

import styles from '../../styles.module.scss'

type InputCellProps = FieldProps & {
  id?: string
  className?: string
  placeholder?: string
  tabIndex?: number
  disabled?: boolean
  readOnly?: boolean
  autoComplete?: string
}

export const InputCell = ({
  name,
  label,
  className,
  container,
  error,
  withoutError = false,
  leftIcon,
  ...rest
}: InputCellProps) => {
  const [field, meta, helpers] = useField<string>(name)

  return (
    <div {...container}>
      {label}
      <div
        className={classNames(styles.input, className, {
          [styles.error]: meta.error && meta.touched
        })}
        style={{
          paddingLeft: leftIcon ? '0.5rem' : null
        }}
      >
        {leftIcon && <div>{leftIcon}</div>}
        <IMaskInput
          mask="(00) 00000-0000"
          value={field.value}
          onAccept={(value: string) => helpers.setValue(value)}
          onBlur={() => helpers.setTouched(true)}
          className="w-full"
          {...rest}
        />
      </div>
      {!withoutError && (
        <FieldError touched={meta.touched} error={meta.error} {...error} />
      )}
    </div>
  )
}
